import {setCurrentStep} from '../TransferOrganizationAccountSlice';

const brandNameHe = () => window.Config?.brand_Name_HE;

export enum TransferAccountStep {
  SelectCompany = 'SelectCompany',
  TransferLine = 'TransferLine',
  PlanSelection = 'PlanSelection',
  EsimConfirmation = 'EsimConfirmation',
  EsimInstruction = 'EsimInstruction',
  DeliveryPersonalInfo = 'DeliveryPersonalInfo',
  DeliveryTimeSlot = 'DeliveryTimeSlot',
  SimOrderSuccessPage = 'SimOrderSuccessPage',
  EsimSuccessPage = 'EsimSuccessPage',
  GeneralMessage = 'GeneralMessage',
}

export enum simCardType {
  undefined = 'undefined',
  sim = 'sim',
  eSim = 'eSim',
}

export enum transferOption {
  undefined = 'undefined',
  newLine = 'newLine',
  niud = 'niud',
}
export enum SelectedPackageType {
  org = 'org',
  epi = 'epi',
}
export enum PopupEnum {
  ServiceFormPopup = 'ServiceFormPopup',
  DeviceSupportsESIM = 'DeviceSupportsESIM',
  SimNumberHelper = 'SimNumberHelper',
  DeviceSupportsESIMCheckBox = 'DeviceSupportsESIMCheckBox',
  PricePlanDetailsPopUp = 'PricePlanDetailsPopUp',
  DeleteEsimInstruction = 'DeleteEsimInstruction',
}

export const errorTxt = {
  confirmationMail: 'כתובות המייל שהזנת אינן תואמות',
  ActivationSubscriptionNotChecked: 'אנא אשר את הפעלת המנוי',
  simCardCountEmpty: 'כדי להתקדם בתהליך עליך להזין מספר כרטיסים',
  simCardMaxCount: 'עברת את מכסת הכרטיסים שניתן להזמין',
};


export enum MessagePage {
  NotSupportsEsim = 'NotSupportsEsim',
  SimNumberHelper = 'SimNumberHelper',
  DeviceSupportsESIM = 'DeviceSupportsESIM',
  GeneralError = 'GeneralError',
}

export enum MessageFormat {
  Page = 'Page',
  Popup = 'Popup',
}
export enum ButtonColor {
  white = 'white',
  primary = 'primary',
}
export const IconList = {
  error: require('../icons/error.svg'),
  success: require('../icons/success.svg'),
  info: require('../icons/info.svg'),
  light: require('../icons/light.svg'),
};

export const MessageContent = {
  GeneralError: {
    title: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
    icon: IconList.error,
    buttonText: 'הבנתי, תודה',
    redirectPath: 'businessLobby',
    format: MessageFormat.Page,
  },
  NoBans: {
    title: 'לקוח יקר, לא ניתן להתקדם בתהליך,',
    secondTitle: 'נא פנה לאחראית שירות להמשך טיפול – מספר שגיאה 170701',
    icon: IconList.error,
    buttonText: 'חזרה לאזור האישי',
    redirectPath: 'businessLobby',
    format: MessageFormat.Page,
  },
  niudCellcom: {
    get title() {
      return `מספר הטלפון {selectedPhoneNumber} כבר מנוי ב${brandNameHe()}.`;
    },
    secondTitle: 'במקרה של בעיה פנה לאחראי השירות – מספר שגיאה 122501',
    icon: IconList.error,
    buttonText: 'להזנת מספר אחר',
    buttonClick: 'goToTransferLineStep',
    secondButtonText: 'חזרה לאזור האישי',
    redirectPath: 'businessLobby',
    format: MessageFormat.Page,
  },

  niudNumberError: {
    title: 'לקוח יקר, לא ניתן להתקדם בתהליך,',
    secondTitle: 'נא פנה לאחראית שירות להמשך טיפול- מספר שגיאה 122599',
    icon: IconList.error,
    buttonText: 'להזנת מספר אחר',
    buttonClick: 'goToTransferLineStep',
    secondButtonText: 'חזרה לאזור האישי',
    redirectPath: 'businessLobby',
    format: MessageFormat.Page,
  },
  niudTempNumberError: {
    title: 'לקוח יקר, לא ניתן להתקדם בתהליך,',
    secondTitle: 'נא פנה לאחראית שירות להמשך טיפול- מספר שגיאה 002499',
    icon: IconList.error,
    buttonText: 'חזרה לאזור האישי',
    redirectPath: 'businessLobby',
    format: MessageFormat.Page,
  },
  niudTempNumberNotFound: {
    title: 'לקוח יקר, לא ניתן להתקדם בתהליך,',
    secondTitle: 'נא פנה לאחראית שירות להמשך טיפול- מספר שגיאה 002401',
    icon: IconList.error,
    buttonText: 'חזרה לאזור האישי',
    redirectPath: 'businessLobby',
    format: MessageFormat.Page,
  },
  PricePlanNotFound: {
    title: 'לא נמצאו תוכניות מתאימות',
    secondTitle: 'במידת הצורך פנו לאחראי/ת השירות',
    icon: IconList.error,
    buttonText: 'חזרה לאזור האישי',
    redirectPath: 'businessLobby',
    format: MessageFormat.Page,
  },

  SimActivatedSucceeded: {
    title: 'ה-SIM החדש הופעל  בהצלחה!',
    secondTitle: 'הודעה על ניוד הקו נשלחה למנוי {selectedPhoneNumber} לשם השלמת התהליך',
    icon: IconList.success,
    buttonText: 'הפעלת קו נוסף',
    buttonClick: 'resetState',
    format: MessageFormat.Page,
    success: true,
  },
  NewLineActivationSucceeded: {
    title: 'ה-SIM החדש הופעל למנוי {selectedPhoneNumber} בהצלחה!',
    secondTitle: 'על המנוי לכבות את המכשיר ולהכניס את ה-SIM החדש',
    icon: IconList.success,
    buttonText: 'הפעלת קו נוסף',
    buttonClick: 'resetState',
    format: MessageFormat.Page,
    success: true,
  },
  NoPlansForPlatform: {
    title: 'לא נמצאו תוכניות לציוד שנבחר',
    secondTitle: 'במידת הצורך פנו לאחראי/ת השירות',
    icon: IconList.error,
    buttonText: 'חזרה לאזור האישי',
    redirectPath: 'businessLobby',
    format: MessageFormat.Page,
  },
};

export const deleteEsimInstruction = [
  'לאחר הפעלת ה-eSIM החדש יש להיכנס להגדרות ולהגדירו כראשי',
  'אם אין לך צורך ב-eSIM הישן, יש למחוק אותו לפי הפעלת ה-eSIM החדש, ואז החדש יוגדר אוטומטית כראשי',
  'במידה ומותקנים במכשיר יותר מ-eSIM אחד יש למחוק את כולם כדי שהחדש יוגדר ראשי ',
];

export const deleteEsimBySystem = [
  {
    icon: require('../icons/IosIcon.svg'),
    text: 'הגדרות > סלולרי > בוחרים מרשימת כרטיסי SIM את ה-eSIM שרוצים למחוק > מחיקת eSIM > מאשרים את המחיקה חוזרים לרשימת כרטיסי SIM > בוחרים שוב את הכרטיס שמחקנו > בוחרים ״השתמש בראשי״',
  },
  {
    icon: require('../icons/androidIcon.svg'),
    text: 'הגדרות > חיבורים > מנהל SIM בוחרים מרשימת כרטיסי SIM את ה-eSIM שרוצים למחוק > הסר > מאשרים את ההסרה',
  },
];

export enum DwhActionType {
  ChoosePackagePageRegularSIM = 'Choose package Page Regular SIM',
  SuccessScreenRegularSIM = 'Success Screen Regular SIM',
  ErrorScreen = 'Error Screen',
  ChoosePackagePageESIM = 'Choose package Page eSIM',
  ESIMInstructionsPage = 'eSIM Instructions Page',
  SuccessScreenESIM = 'Success Screen eSIM',
  DeliveryDetailsPageRegularSIM = 'Delivery Details Page Regular SIM',
  SuccessScreenDeliveryRegularSIM = 'Success Screen Delivery Regular SIM',
  ChooseDeliveryTime = 'Choose Delivery Time',
}
export enum DWHMessageText {
  PackageSIMDisplayed = 'Package Selection Regular SIM Page Displayed',
  PackageSIMClicked = 'Package Selection Regular SIM Button Clicked',
  SuccessScreenSIM = 'Success Screen Regular SIM',
  GeneralError = 'General Error',
  PackageESIMDisplayed = 'Package Selection eSIM Page Displayed',
  PackageESIMClick = 'Package Selection eSIM Button Clicked',
  ESIMInstructionsDisplayed = 'eSIM Instructions Page Displayed',
  ESIMInstructionsBtnClick = 'eSIM Instructions Page Button Clicked',
  SuccessScreenESIM = 'Success Screen eSIM',
  DeliveryDetailsSimDisplay = 'Delivery Details Page Regular SIM Displayed',
  DeliveryDetailsButtonClicked = 'Delivery Details Page Regular SIM Button Clicked',
  ChooseDeliveryTimeDisplayed = 'Choose Delivery Time Page Displayed',
  SuccessScreenDeliverySIM = 'Success Screen Delivery Regular SIM',
}
export enum DWHStatus {
  Ongoing = 'Ongoing',
  Completed = 'Completed',
  Error = 'Error',
}
